<div flot [dataset]="stackedBarData" [options]="barStackedOptions" height="{{stackedBarHeight}}"></div>